(function () {
  function boot(root) {
    if (root.dataset.coveringReady) return;
    root.dataset.coveringReady = '1';

    var boundOpeners = new WeakSet();
    var opener = root.querySelector('[data-covering-open-proxy]');
    var dialog = root.querySelector('[data-covering-dialog]');
    var selectedLabel = root.querySelector('[data-covering-selected-label]');
    var tabs = Array.from(root.querySelectorAll('[data-covering-tab]'));
    var panels = Array.from(root.querySelectorAll('[data-covering-panel]'));
    var count = root.querySelector('[data-swatch-count]');
    var list = root.querySelector('[data-swatch-selected]');
    var message = root.querySelector('[data-swatch-message]');
    var large = root.querySelector('[data-large-preview]');
    var packId = root.dataset.packVariant;
    var shopRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
    var selected = new Map();
    var busy = false;
    var ready = false;
    // Seat selection is independent of the sample pack in the basket.
    var draftSeat = null;
    var attachedSeat = null;
    var seatSummary = root.querySelector('[data-seat-colour-summary]');
    var seatApply = root.querySelector('[data-seat-colour-apply]');
    var seatMessage = root.querySelector('[data-seat-colour-message]');
    var seatStatus = null;

    function productScope() {
      return Array.from(document.querySelectorAll('product-info[data-product-id]')).find(function (info) {
        return info.dataset.productId === root.dataset.productId && info.querySelector('variant-selects[data-primary]');
      }) || null;
    }

    function coveringInputs() {
      var scope = productScope();
      var picker = scope && scope.querySelector('variant-selects[data-primary]');
      return picker ? Array.from(picker.querySelectorAll('input[type="radio"], select')).filter(function (input) {
        return /seat covering/i.test(input.name || '');
      }) : [];
    }

    function keyOf(value) {
      return String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    }

    function syncSeat() {
      var scope = productScope();
      if (!scope) return;
      if (attachedSeat && attachedSeat.covering !== selectedCovering()) attachedSeat = null;
      var properties = attachedSeat ? {
        'Seat material': attachedSeat.range,
        'Seat colour': attachedSeat.name,
        'Material reference': attachedSeat.reference,
        'Colour confirmation': 'Subject to sample confirmation',
        '_cinema_deco_seat_swatch': attachedSeat.id
      } : {};
      scope.querySelectorAll('form[data-type="add-to-cart-form"]').forEach(function (form) {
        form.querySelectorAll('[data-cd-seat-property]').forEach(function (input) {
          var value = properties[input.dataset.cdSeatProperty];
          input.disabled = !value;
          if (input.value !== (value || '')) input.value = value || '';
        });
      });
      document.querySelectorAll('cd-seat-price-breakdown[data-product-id]').forEach(function (box) {
        if (box.dataset.productId !== root.dataset.productId) return;
        var row = box.querySelector('[data-cd-chosen-covering-row]');
        var value = box.querySelector('[data-cd-chosen-covering]');
        var coveringText = attachedSeat ? attachedSeat.range + ' · ' + attachedSeat.name : '';
        if (value && value.textContent !== coveringText) value.textContent = coveringText;
        if (row) row.hidden = !attachedSeat;
      });
      var text = attachedSeat ? attachedSeat.range + ' · ' + attachedSeat.name + ' — Subject to sample confirmation' : '';
      if (seatStatus && seatStatus.textContent !== text) seatStatus.textContent = text;
      if (seatStatus) seatStatus.hidden = !text;
    }

    function drawSeat() {
      root.querySelectorAll('[data-seat-colour-select]').forEach(function (button) {
        var card = button.closest('[data-swatch-id]');
        var active = !!draftSeat && draftSeat.id === card.dataset.swatchId && draftSeat.covering === card.dataset.swatchCovering;
        button.setAttribute('aria-pressed', String(active));
        card.classList.toggle('is-seat-selected', active);
      });
      var summaryText = draftSeat ? draftSeat.range + ' · ' + draftSeat.name : 'Select a colour for your seats';
      if (seatSummary.textContent !== summaryText) seatSummary.textContent = summaryText;
      seatApply.disabled = !draftSeat;
      var applyText = attachedSeat && draftSeat && attachedSeat.id === draftSeat.id && attachedSeat.covering === draftSeat.covering ? 'Use this colour and return to seats' : 'Use this colour for my seats';
      if (seatApply.textContent !== applyText) seatApply.textContent = applyText;
      syncSeat();
    }

    function applySeat() {
      if (!draftSeat) return;
      var radio = coveringInputs().find(function (input) {
        return input.type === 'radio' && keyOf(input.value) === draftSeat.covering;
      });
      var select = coveringInputs().find(function (input) {
        return input.tagName === 'SELECT' && Array.from(input.options).some(function (option) {
          return keyOf(option.value) === draftSeat.covering && !option.disabled;
        });
      });
      if ((!radio || radio.disabled || radio.classList.contains('disabled')) && !select) {
        seatMessage.textContent = 'This covering is unavailable for the selected seat configuration. Choose another covering.';
        return;
      }
      var input = radio && !radio.disabled && !radio.classList.contains('disabled') ? radio : select;
      attachedSeat = Object.assign({}, draftSeat);
      if (input === radio) radio.checked = true;
      else select.value = Array.from(select.options).find(function (option) { return keyOf(option.value) === draftSeat.covering; }).value;
      syncSeat();
      input.dispatchEvent(new Event('change', { bubbles: true }));
      seatMessage.textContent = 'Saved to your seat selection. Confirm the final colour after your samples arrive.';
      drawSeat();
      dialog.close();
      if (opener) opener.focus();
    }

    seatApply.addEventListener('click', applySeat);
    document.addEventListener('submit', function (event) {
      var scope = productScope();
      if (scope && scope.contains(event.target)) syncSeat();
    }, true);


    root.querySelectorAll('.cd-covering-drawer__head p').forEach(function (paragraph) {
      if (paragraph.textContent.indexOf('Choose your covering type on the seat page.') !== -1) paragraph.remove();
    });

    function label(swatch) {
      return [swatch.range, swatch.name, swatch.reference].filter(Boolean).join(' / ');
    }

    function swatchFromCard(card) {
      return {
        id: card.dataset.swatchId,
        name: card.dataset.swatchName,
        reference: card.dataset.swatchReference,
        range: card.dataset.swatchRange
      };
    }

    function selectedCovering() {
      var radio = coveringInputs().filter(function (input) { return input.type === 'radio' && input.checked; })
        .find(function (input) { return /seat covering/i.test(input.name); });
      var select = coveringInputs().filter(function (input) { return input.tagName === 'SELECT'; })
        .find(function (input) { return /seat covering/i.test(input.name); });
      var value = radio && radio.value || select && select.value || '';
      return value.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    }

    function selectedCoveringLabel() {
      var radio = coveringInputs().filter(function (input) { return input.type === 'radio' && input.checked; })
        .find(function (input) { return /seat covering/i.test(input.name); });
      var select = coveringInputs().filter(function (input) { return input.tagName === 'SELECT'; })
        .find(function (input) { return /seat covering/i.test(input.name); });
      return (radio && radio.value || select && select.value || 'covering').trim();
    }

    function updateSelectedLabel() {
      if (selectedLabel) selectedLabel.textContent = selectedCoveringLabel();
    }

    function activate(key) {
      if (!tabs.some(function (tab) { return tab.dataset.coveringTab === key; })) {
        key = tabs[0] && tabs[0].dataset.coveringTab;
      }
      tabs.forEach(function (tab) {
        tab.setAttribute('aria-selected', String(tab.dataset.coveringTab === key));
      });
      panels.forEach(function (panel) { panel.hidden = panel.dataset.coveringPanel !== key; });
      large.hidden = true;
    }

    function positionButton() {
      var control = Array.from((productScope() || root).querySelectorAll('.product-form__input')).find(function (item) {
        var label = item.querySelector('legend, .form__label');
        var namedInput = Array.from(item.querySelectorAll('input, select')).some(function (input) {
          return /seat covering/i.test(input.name || '');
        });
        return namedInput || label && label.textContent.trim().toLowerCase().indexOf('seat covering') === 0;
      });
      if (!control) return;
      if (!seatStatus) { seatStatus = document.createElement('p'); seatStatus.className = 'cd-covering-drawer__seat-status'; seatStatus.setAttribute('aria-live', 'polite'); }
      if (!opener) {
        opener = document.createElement('button');
        opener.type = 'button';
        opener.className = 'cd-covering-drawer__opener';
        opener.dataset.coveringOpenProxy = '';
      }
      // Bind here as the button may be created after boot or moved by a variant refresh.
      if (!boundOpeners.has(opener)) {
        opener.addEventListener('click', function (event) {
          event.preventDefault();
          openDrawer();
        });
        boundOpeners.add(opener);
      }
      opener.setAttribute('aria-haspopup', 'dialog');
      if (dialog.id) opener.setAttribute('aria-controls', dialog.id);
      var text = 'Choose ' + selectedCoveringLabel().toLowerCase() + ' colours and order samples';
      if (opener.textContent !== text) opener.textContent = text;
      if (opener.parentElement !== control.parentElement || opener.previousElementSibling !== control) {
        control.insertAdjacentElement('afterend', opener);
      }
      if (seatStatus.parentElement !== opener.parentElement || seatStatus.previousElementSibling !== opener) opener.insertAdjacentElement('afterend', seatStatus);
      syncSeat();
    }

    function draw() {
      count.textContent = selected.size + ' of 5 selected';
      var basket = root.querySelector('[data-swatch-basket]');
      if (basket) basket.setAttribute('aria-disabled', String(busy || !ready || !selected.size));
      list.replaceChildren();
      selected.forEach(function (swatch, id) {
        var li = document.createElement('li');
        var text = document.createElement('span');
        text.textContent = [swatch.range, swatch.name].filter(Boolean).join(' · ');
        var remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'cd-covering-drawer__remove';
        remove.textContent = '×';
        remove.setAttribute('aria-label', 'Remove ' + swatch.name + ' from sample pack');
        remove.disabled = busy || !ready;
        remove.addEventListener('click', function () { change(id, null); });
        li.append(remove, text);
        list.append(li);
      });
      root.querySelectorAll('[data-swatch-add]').forEach(function (button) {
        var card = button.closest('[data-swatch-id]');
        var isSelected = selected.has(card.dataset.swatchId);
        button.replaceChildren();
        if (isSelected) {
          var tick = document.createElement('span');
          tick.className = 'cd-covering-drawer__sample-tick';
          tick.setAttribute('aria-hidden', 'true');
          tick.style.setProperty('--cd-tick-url', 'url("' + root.dataset.tickUrl + '")');
          button.append(tick);
        }
        button.append(document.createTextNode(isSelected ? 'Sample added' : selected.size >= 5 ? 'Pack full' : 'Add sample to pack'));
        button.setAttribute('aria-pressed', String(isSelected));
        button.disabled = busy || !ready || !packId || (!isSelected && selected.size >= 5);
      });
    }

    function setMessage(text) { message.textContent = text; }

    async function request(path, body) {
      var response = await fetch(shopRoot + path, {
        method: body ? 'POST' : 'GET',
        headers: { 'Content-Type': 'application/json' },
        cache: 'no-store',
        body: body ? JSON.stringify(body) : undefined
      });
      var result = await response.json();
      if (!response.ok) throw new Error(result.description || 'The basket could not be updated.');
      return result;
    }

    function findPack(cart) {
      var packs = cart.items.filter(function (item) { return String(item.variant_id) === String(packId); });
      if (packs.length > 1 || packs.some(function (item) { return item.quantity !== 1; })) {
        throw new Error('There is more than one sample pack in the basket. Please check the basket before selecting colours.');
      }
      return packs[0] || null;
    }

    function readSelection(item) {
      if (!item) return new Map();
      var stored = item.properties && item.properties._cinema_deco_swatches;
      if (stored) {
        var values = JSON.parse(stored);
        if (!Array.isArray(values) || values.length > 5 || values.some(function (s) { return !s.id || !s.name; })) {
          throw new Error('The existing sample pack needs checking in your basket.');
        }
        return new Map(values.map(function (s) { return [s.id, s]; }));
      }
      var known = new Map();
      root.querySelectorAll('[data-swatch-id]').forEach(function (card) {
        var swatch = swatchFromCard(card);
        known.set(label(swatch), swatch);
      });
      var labels = Object.entries(item.properties || {}).filter(function (entry) { return /^Swatch [1-5]$/.test(entry[0]); });
      if (!labels.length) throw new Error('The existing sample pack needs checking in your basket.');
      var fallback = labels.map(function (entry) { return known.get(entry[1]); });
      if (fallback.some(function (swatch) { return !swatch; })) throw new Error('The existing sample pack contains an unrecognised colour.');
      return new Map(fallback.map(function (swatch) { return [swatch.id, swatch]; }));
    }

    async function refreshHeader(cart) {
      try {
        var ids = ['mini-cart', 'cart-icon-bubble', 'mobile-cart-icon-bubble'];
        var sections = await request('?sections=' + ids.join(','));
        ids.forEach(function (id) {
          var current = document.getElementById(id);
          if (!current || !sections[id]) return;
          var parsed = new DOMParser().parseFromString(sections[id], 'text/html');
          var replacement = parsed.querySelector('.shopify-section');
          if (replacement) current.innerHTML = replacement.innerHTML;
        });
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      } catch (_) {
        setMessage('Your sample pack is saved. Refresh the basket to see the latest selection.');
      }
    }

    async function load() {
      if (!packId) { setMessage('Select the sample pack product in this section’s settings.'); draw(); return; }
      busy = true; draw(); setMessage('Loading your sample pack…');
      try {
        var cart = await request('cart.js');
        selected = readSelection(findPack(cart));
        ready = true;
        setMessage(selected.size ? 'Your sample pack is in your basket.' : 'Choose up to five colours.');
      } catch (error) {
        ready = false;
        setMessage(error.message || 'Could not load your basket.');
      } finally { busy = false; draw(); }
    }

    async function change(id, swatch) {
      if (busy || !ready) return;
      busy = true; draw(); setMessage('Updating your sample pack…');
      try {
        var cart = await request('cart.js');
        var existing = findPack(cart);
        var current = readSelection(existing);
        if (swatch && current.size >= 5 && !current.has(id)) {
          selected = current;
          setMessage('Your pack is full. Remove a colour to add another.');
          return;
        }
        var next = new Map(current);
        if (swatch) next.set(id, swatch); else next.delete(id);
        var properties = {
          _cinema_deco_pack: 'v1',
          _cinema_deco_swatches: JSON.stringify(Array.from(next.values()))
        };
        Array.from(next.values()).forEach(function (item, index) { properties['Swatch ' + (index + 1)] = label(item); });
        if (existing) {
          var retained = Object.fromEntries(Object.entries(existing.properties || {}).filter(function (entry) { return !/^Swatch \d+$/.test(entry[0]); }));
          await request('cart/change.js', {
            id: existing.key,
            quantity: next.size ? 1 : 0,
            properties: next.size ? Object.assign(retained, properties) : undefined
          });
        } else if (next.size) {
          await request('cart/add.js', { items: [{ id: packId, quantity: 1, properties: properties }] });
        }
        var confirmed = await request('cart.js');
        selected = readSelection(findPack(confirmed));
        if (selected.size !== next.size || Array.from(next.keys()).some(function (key) { return !selected.has(key); })) {
          throw new Error('Shopify did not save the selected colours.');
        }
        setMessage(selected.size === 5 ? 'Your pack is full. All five colours are saved.' : selected.size ? 'Your sample pack is saved in the basket.' : 'The empty pack was removed from the basket.');
        await refreshHeader(confirmed);
      } catch (error) {
        try { selected = readSelection(findPack(await request('cart.js'))); } catch (_) { ready = false; }
        setMessage((error.message || 'Could not update the basket.') + ' Please check your basket.');
      } finally { busy = false; draw(); }
    }

    function openDrawer() {
      draftSeat = attachedSeat ? Object.assign({}, attachedSeat) : draftSeat;
      drawSeat();
      if (!dialog.open) {
        try {
          if (typeof dialog.showModal === 'function') dialog.showModal();
          else dialog.setAttribute('open', '');
        } catch (_) {
          dialog.setAttribute('open', '');
        }
      }
      updateSelectedLabel();
      try { activate(selectedCovering()); } catch (_) {}
      try { load(); } catch (_) {}
    }
    root.querySelector('[data-covering-close]').addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('click', function (event) { if (event.target === dialog) dialog.close(); });
    tabs.forEach(function (tab) { tab.addEventListener('click', function () { activate(tab.dataset.coveringTab); }); });
    root.addEventListener('click', function (event) {
      var choose = event.target.closest('[data-seat-colour-select]');
      if (choose) {
        var seatCard = choose.closest('[data-swatch-id]');
        draftSeat = Object.assign(swatchFromCard(seatCard), { covering: seatCard.dataset.swatchCovering });
        seatMessage.textContent = '';
        drawSeat();
      }
      var basket = event.target.closest('[data-swatch-basket]');
      if (basket && basket.getAttribute('aria-disabled') === 'true') event.preventDefault();
      var add = event.target.closest('[data-swatch-add]');
      if (add && !add.disabled) {
        var card = add.closest('[data-swatch-id]');
        var swatch = swatchFromCard(card);
        change(swatch.id, selected.has(swatch.id) ? null : swatch);
      }
      var preview = event.target.closest('[data-swatch-preview]');
      if (preview) {
        var previewCard = preview.closest('[data-swatch-id]');
        var url = previewCard.querySelector('[data-large-url]');
        if (url) {
          var image = large.querySelector('[data-large-image]');
          image.src = url.dataset.largeUrl;
          image.alt = previewCard.dataset.swatchName;
          large.hidden = false;
          large.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        }
      }
    });
    root.querySelector('[data-large-close]').addEventListener('click', function () { large.hidden = true; });
    document.addEventListener('change', function () { syncSeat(); drawSeat(); if (dialog.open) { updateSelectedLabel(); activate(selectedCovering()); } positionButton(); });
    document.addEventListener('cinema-deco:covering-control-ready', positionButton);
    var scope = document.querySelector('main') || document;
    var placementTimer;
    var placementObserver = new MutationObserver(function () {
      if (!root.isConnected) { placementObserver.disconnect(); return; }
      clearTimeout(placementTimer);
      placementTimer = setTimeout(function () { positionButton(); drawSeat(); }, 0);
    });
    placementObserver.observe(scope, { childList: true, subtree: true });
    positionButton();
    updateSelectedLabel();
    draw();
    drawSeat();
  }

  function bootAll() { document.querySelectorAll('[data-covering-drawer]').forEach(boot); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootAll);
  else bootAll();
  document.addEventListener('shopify:section:load', bootAll);
})();
